export enum SortDirection { NONE, ASCENDING, DESCENDING }